import React from 'react';
import FilterSelect from '../../../../../../../common/components/Form/filterInputs/Select';
import { timeZoneOption } from '../options';

function TimeZone({ value, onChange }) {
  return (
    <FilterSelect
      className="filter filter-time-zone"
      label="Time Zone:"
      name="utc"
      value={value}
      onChange={onChange}
      style={{
        minWidth: '125px',
      }}
      options={timeZoneOption}
    />
  );
}

export default TimeZone;
